'use client'

import { TNotice } from '@/entities/support'
import { UserType } from '@/entities/user'
import { useFormatDate } from '@/shared/lib'
import { MobileLayout, Separator } from '@/shared/ui'

import { Content } from '../content'
import { MobileHeader } from '../header'
import { MobileNavigation } from '../navigation'

type Props = {
  userType: UserType
  notice: TNotice
}

export const MobileNoticeDetail = ({ userType, notice }: Props) => {
  const { formatDate } = useFormatDate()

  return (
    <>
      <MobileLayout className="pt-6 pb-0">
        <MobileHeader
          title={notice.title}
          createdAt={formatDate({ date: notice.writeDate })}
        />
        <Separator color="black" />
        <Content contents={notice.contents} />
      </MobileLayout>
      <Separator color="light-gray" size="large" />
      <MobileNavigation
        userType={userType}
        previous={notice.previous}
        next={notice.next}
      />
    </>
  )
}
